var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69141 11.2603C6.03332 12.7423 5 15.0844 5 18.5882V33.4118C5 36.9156 6.03332 39.2577 7.69141 40.7397C9.36948 42.2396 11.8445 43 15 43H37C40.1555 43 42.6305 42.2396 44.3086 40.7397C45.9667 39.2577 47 36.9156 47 33.4118V18.5882C47 15.0844 45.9667 12.7423 44.3086 11.2603C42.6305 9.76041 40.1555 9 37 9H15C11.8445 9 9.36948 9.76041 7.69141 11.2603ZM6.35859 9.76912C8.53052 7.82782 11.5555 7 15 7H37C40.4445 7 43.4695 7.82782 45.6414 9.76912C47.8333 11.7283 49 14.6803 49 18.5882V33.4118C49 37.3197 47.8333 40.2717 45.6414 42.2309C43.4695 44.1722 40.4445 45 37 45H15C11.5555 45 8.53052 44.1722 6.35859 42.2309C4.16668 40.2717 3 37.3197 3 33.4118V18.5882C3 14.6803 4.16668 11.7283 6.35859 9.76912Z",
    fill: "#EC923C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.303 17.2829C15.6991 16.898 16.3322 16.907 16.7171 17.303L22.9549 23.7213L22.9559 23.7224C24.6236 25.426 27.3571 25.4259 29.0245 23.7219L35.284 17.3019C35.6695 16.9065 36.3027 16.8984 36.6981 17.284C37.0935 17.6695 37.1015 18.3027 36.716 18.6981L30.4549 25.1198C28.0026 27.6267 23.9774 27.6267 21.5251 25.1198L21.5229 25.1175L15.2829 18.697C14.898 18.3009 14.907 17.6678 15.303 17.2829Z",
    fill: "#EC923C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOrange);
export default __webpack_public_path__ + "static/media/emailOrange.de0db83b.svg";
export { ForwardRef as ReactComponent };